<template>
  <div
    id="census"
    class="census"
    :style="{ zoom: screenIndexWidth < 1600 ? 0.8 : 1 }"
  >
    <!--    <div class="census-select mgn-b">-->
    <!--      <el-select v-model="flagParcel" placeholder="请选择" @change="changeFlag">-->
    <!--        <el-option-->
    <!--          :label="item.label"-->
    <!--          :value="item.value"-->
    <!--          v-for="(item, index) in flagList"-->
    <!--          :key="index"-->
    <!--        >-->
    <!--        </el-option>-->
    <!--      </el-select>-->
    <!--    </div>-->
    <div class="census-land">
      <div class="census-land-li mgn-b">
        <!-- <div class="census-land-li-l">
          <div>地块</div>
          <div>统计</div>
        </div> -->
        <div class="census-land-li-r">
          <div class="census-land-li-r-box">
            <div
              class="census-land-li-r-box-l"
              @click="showLandList('上架地块', null, 3, null, county)"
            >
              <img src="@/assets/images/home/lan-icon.png" alt="" />
            </div>
            <div class="census-land-li-r-box-r">
              <div class="census-land-li-r-box-r-span">上架地块</div>
              <div class="census-land-li-r-box-r-span">
                <span class="number-n">{{ censusInfo.parcelSum }}</span
                ><span class="span-c">宗</span>
              </div>
              <div class="other-land">
                <span class="number-c">{{ censusInfo.parcelArea }}</span>
                <span class="span-c">亩</span>
              </div>
            </div>
          </div>
          <div class="census-land-li-r-box">
            <div
              class="census-land-li-r-box-l"
              @click="showLandList('待成交地块', null, null, 1, county)"
            >
              <img src="@/assets/images/home/nopay-icon.png" alt="" />
            </div>
            <div class="census-land-li-r-box-r">
              <div class="census-land-li-r-box-r-span">未成交地块</div>
              <div class="census-land-li-r-box-r-span">
                <span class="number-n">{{
                  censusInfo.notTransactionCount
                }}</span
                ><span class="span-c">宗</span>
              </div>
              <div class="other-land">
                <span class="number-c">{{
                  censusInfo.notTransactionArea
                }}</span>
                <span class="span-c">亩</span>
              </div>
            </div>
          </div>
          <div class="census-land-li-r-box">
            <div
              class="census-land-li-r-box-l"
              @click="showLandList('已成交地块', null, null, 2, county)"
            >
              <img src="@/assets/images/home/pay-icon.png" alt="" />
            </div>
            <div class="census-land-li-r-box-r">
              <div class="census-land-li-r-box-r-span">已成交地块</div>
              <div class="census-land-li-r-box-r-span">
                <span class="number-n">{{ censusInfo.transactionCount }}</span
                ><span class="span-c">宗</span>
              </div>
              <div class="other-land">
                <span class="number-c">{{ censusInfo.transactionArea }}</span>
                <span class="span-c">亩</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div
        style="
          font-size: 0.95rem;
          font-weight: 600;
          margin-bottom: 5px;
          color: #333333;
        "
      >
        未成交
      </div> -->
      <div
        style="
          border-left: 1px dashed #c9c7c7;
          border-right: 1px dashed #c9c7c7;
          border-top: 1px dashed #c9c7c7;
        "
      >
        <div
          style="
            font-size: 0.95rem;
            font-weight: 400;
            padding-left: 10px;
            padding-top: 5px;
            color: #999999;
          "
        >
          未成交
        </div>
        <div style="padding: 10px 20px" class="census-land-li2">
          <div class="census-land-li1-bot">
            <div
              @click="showLandList('立等可供', null, null, '1', county, 1)"
              style="cursor: pointer"
            >
              <img src="@/assets/images/common/img001.png" />
            </div>
            <div class="census-land-li1-bot-r">
              <div class="census-land-li1-r-box-r-span land2">
                <span>立等可供</span>
              </div>
              <div>
                <span style="margin-left: 0" class="number-n">{{
                  available.waitingForSupplyCount
                }}</span>
                <span class="span-n">宗</span>
              </div>
              <div class="other-land">
                <span class="number-c">{{
                  available.waitingForSupplyArea
                }}</span>
                <span class="span-c">亩</span>
              </div>
            </div>
          </div>
          <div class="census-land-li1-bot" style="margin-left: 94px">
            <div
              @click="showLandList('计划可供', null, null, '1', county, 3)"
              style="cursor: pointer"
            >
              <img src="@/assets/images/common/img002.png" />
            </div>
            <div class="census-land-li1-bot-r" style="margin-left: 15px">
              <div class="census-land-li1-r-box-r-span land2">
                <span>计划可供</span>
              </div>
              <div>
                <span style="margin-left: 0" class="number-n">{{
                  available.planAvailableCount
                }}</span>
                <span class="span-n">宗</span>
              </div>
              <div class="other-land">
                <span class="number-c">{{ available.planAvailableArea }}</span>
                <span class="span-c">亩</span>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="census-land-li1-bot">
          <div
            style="cursor: pointer"
          >
            <img src="@/assets/images/common/img003.png" />
          </div>
          <div
            @click="showLandList('规划可用', null, null, null, county, 4)"
            style="cursor: pointer"
          >
            <img src="@/assets/images/common/img003.png" />
          </div>
          <div class="census-land-li1-bot-r">
            <div class="census-land-li1-r-box-r-span land2">
              <span>规划可用</span>
            </div>
            <div style="width: 10px; height: 23px"></div>
            <div class="other-land">
              <span class="number-c">{{
                available.planningAvailableArea
              }}</span>
              <span class="span-c">亩</span>
            </div>
          
          </div>
        </div> -->
      </div>
      <div class="census-land-li1">
        <div class="census-land-li1-r">
          <div class="census-land-li1-r-box1">
            <div
              class="census-land-li1-r-box-l1"
              @click="showLandList('商服用地', 5, null, '1', county)"
            >
              <img src="../../../assets/images/home/syyd.png" />
            </div>
            <div class="census-land-li1-r-box-r">
              <div class="census-land-li1-r-box-r-span">商服用地</div>
              <div style="" class="other-land">
                <span class="number-n">{{ cbList.businessNum }}</span>
                <span class="span-n">宗</span>
              </div>
              <div class="census-land-li1-r-box-r-span2">
                <div style="" class="other-land">
                  <span class="number-c">{{ cbList.businessCount }}</span>
                  <span class="span-c">亩</span>
                </div>
              </div>
            </div>
          </div>
          <div class="census-land-li1-r-box1">
            <div
              class="census-land-li1-r-box-l1"
              @click="showLandList('住宅用地', 7, null, '1', county)"
            >
              <img src="../../../assets/images/home/zzyd.png" />
            </div>
            <div class="census-land-li1-r-box-r">
              <div class="census-land-li1-r-box-r-span">住宅用地</div>
              <div style="" class="other-land">
                <span class="number-n">{{ cbList.liveNum }}</span>
                <span class="span-n">宗</span>
              </div>
              <div class="census-land-li1-r-box-r-span2">
                <div style="" class="other-land">
                  <span class="number-c">{{ cbList.liveCount }}</span>
                  <span class="span-c">亩</span>
                </div>
              </div>
            </div>
          </div>
          <div class="census-land-li1-r-box1">
            <div
              class="census-land-li1-r-box-l1"
              @click="showLandList('工矿仓储用地', 6, null, '1', county)"
            >
              <img src="../../../assets/images/home/gkyd.png" />
            </div>
            <div class="census-land-li1-r-box-r">
              <div class="census-land-li1-r-box-r-span">工矿仓储用地</div>
              <div style="" class="other-land">
                <span class="number-n">{{ cbList.storeNum }}</span>
                <span class="span-n">宗</span>
              </div>
              <div class="census-land-li1-r-box-r-span2">
                <div style="" class="other-land">
                  <span class="number-c">{{ cbList.storeCount }}</span>
                  <span class="span-c">亩</span>
                </div>
              </div>
            </div>
          </div>
          <div class="census-land-li1-r-box1">
            <div
              class="census-land-li1-r-box-l1"
              @click="showLandList('其他用地', 12, null, '1', county)"
            >
              <img src="../../../assets/images/home/qtyd.png" />
            </div>
            <div class="census-land-li1-r-box-r">
              <div class="census-land-li1-r-box-r-span">其他用地</div>
              <div style="" class="other-land">
                <span class="number-n">{{ cbList.otherNum }}</span>
                <span class="span-n">宗</span>
              </div>
              <div class="census-land-li1-r-box-r-span2">
                <div style="" class="other-land">
                  <span class="number-c">{{ cbList.otherCount }}</span>
                  <span class="span-c">亩</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="census-land-li3">
      <div class="programme">
        <img src="@/assets/images/common/img003.png" />
        <div
          class="census-land-li1-r-box-r-span land2"
          style="margin-left: 20px"
        >
          <span>规划可用</span>
        </div>
      </div>
      <div class="programme-area">
        <div class="other-land">
          <span class="number-c">{{ available.planningAvailableArea }}</span>
          <span class="span-c">亩</span>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="dialogTableVisible" :modal="false">
      <slot name="title">
        <div class="dialogTitle">
          <!--<img src="../../../assets/images/home/syyd.png" /><span>商服用地</span>-->
          <img :src="dialogTableTitle.img" /><span>{{
            dialogTableTitle.text
          }}</span>
        </div>
      </slot>
      <info-table :search-land="searchLand"></info-table>
    </el-dialog>
  </div>
</template>
<script>
import MapBox from "../components/mapBox";
import { dictionaries } from "@/api/common/index";
import {
  statisticalParcelStatus,
  getTransactionInfo,
  getSupplyPeriodIndex,
} from "@/api/setting/investment";
import * as echarts from "echarts";
import InfoTable from "@/views/home/components/infoTable";

export default {
  name: "census",
  components: { InfoTable, MapBox },
  props: {
    county: {
      type: String,
      default: "53",
    },
  },
  data() {
    return {
      screenIndexWidth: null,
      flagParcel: 1, //地块统计条件
      flagParcel1: 1,
      flagParcel2: 1,
      flagRequirement: 1, //用地需求条件
      flagRequirementInfo: {},
      flagList: [
        { value: 1, label: "近一个月" },
        { value: 2, label: "近三个月" },
        { value: 3, label: "近半年" },
        { value: 4, label: "近一年" },
      ],
      parkCensus: {},
      landCensus: {},
      countyList: [{ value: "53", label: "云南省", is_check: true }],
      parkList: [], //园区列表
      searchInfo: {
        size: 10,
        current: 1,
        total: 0,
      },
      landList: [],
      dialogTableVisible: false,
      dialogTableTitle: {
        img: "",
        text: "",
      },
      yqjbList: [], //园区级别
      dklxList: [], //地块类型
      type: "",
      parkLoading: false,
      landLoading: false,
      parkVal: "",
      landVal: "",
      cbList: {}, //招商用地库
      censusInfo: {}, //交易统计地块
      searchLand: {
        type: "",
        size: 10,
        current: 1,
        approvalStatus: "",
        transaction: "",
        supplyPeriod: "",
        county: 53,
      }, //用地查询
      available: {
        availableInTheNearFutureArea: 0,
        availableInTheNearFutureCount: 0,
        planAvailableArea: 0,
        planAvailableCount: 0,
        waitingForSupplyArea: 0,
        waitingForSupplyCount: 0,
      },
      moreIsShow: false,
    };
  },
  watch: {
    county(val) {
      this.getParkCensus();
      this.getjyInfo();
      this.supplyPeriodIndex();
    },
    // flagParcel(val) {
    //   this.getParkCensus(val);
    // },
  },
  mounted() {
    this.screenIndexWidth = window.screen.width; //初始化网页宽度
    // this.getParcelInfo(this.flagParcel);
    this.getParkCensus(this.flagParcel);
    this.getjyInfo();
    //this.initCensusMap();
    this.supplyPeriodIndex();
  },
  methods: {
    moreShow() {
      this.moreIsShow = !this.moreIsShow;
      let scrollbar = document.getElementById("scrollbar");
      if (this.moreIsShow) {
        scrollbar.scrollLeft = scrollbar.scrollWidth;
      } else {
        scrollbar.scrollLeft = 0;
      }
    },
    getjyInfo() {
      getTransactionInfo({ county: this.county }).then((res) => {
        if (res.data.success) {
          this.censusInfo = res.data.data;

          // this.censusInfo.notTransactionArea = parseInt(
          //   this.censusInfo.notTransactionArea
          // );
          // this.censusInfo.notTransactionCount = parseInt(
          //   this.censusInfo.notTransactionCount
          // );
          // this.censusInfo.parcelArea = parseInt(this.censusInfo.parcelArea);
          // this.censusInfo.parcelSum = parseInt(this.censusInfo.parcelSum);
          // this.censusInfo.transactionArea = parseInt(
          //   this.censusInfo.transactionArea
          // );
          // this.censusInfo.transactionCount = parseInt(
          //   this.censusInfo.transactionCount
          // );
        }
      });
    },
    changeFlag(val) {
      this.getParcelInfo(this.flagParcel);
      this.getjyInfo();
      this.getParkCensus(val);
    },
    getField(field, identification) {
      let data = { field: field };
      dictionaries(field).then((res) => {
        this[identification] = res.data.data;
      });
    },

    changeXzqh(index) {
      this.countyList.splice(index + 1, 1);
      let len = this.countyList.length;
      this.countyList[len - 1].is_check = true;
      this.county = this.countyList[index].value;
      this.$emit("callBackXzqh", this.county);
    },

    //地图点击返回行政区划代码
    callBackCounty(val) {
      this.$emit("callBackXzqh", val);
    },
    //返回行政区划数组
    changeCounty(val) {
      this.countyList = val;
    },
    //加载地图echart
    initCensusMap() {
      let censusMap = echarts.init(document.getElementById("census-map"));
      censusMap.setOption({
        series: [
          {
            type: "map",
          },
        ],
      });
    },

    //园区统计 ,用地统计
    getParkCensus(val) {
      statisticalParcelStatus({ county: this.county }).then((res) => {
        if (res.data.success) {
          let data = res.data.data;
          this.cbList = res.data.data;
          // this.cbList.businessCount = parseInt(this.cbList.businessCount);
          // this.cbList.otherCount = parseInt(this.cbList.otherCount);
          // this.cbList.publicCount = parseInt(this.cbList.publicCount);
          // this.cbList.storeCount = parseInt(this.cbList.storeCount);
          // this.cbList.liveCount = parseInt(this.cbList.liveCount);
          // console.log(this.cbList);
        }
      });
    },

    showLandList(
      typeName,
      type,
      approvalStatus,
      transaction,
      county,
      supplyPeriod
    ) {
      // 如何是全部 就直接跳转至土地超市的列表页面
      this.dialogTableVisible = true;
      this.searchLand.type = type;
      this.searchLand.approvalStatus = approvalStatus;
      this.searchLand.transaction = transaction;
      this.searchLand.current = 1;
      this.searchLand.county = county;

      this.searchLand.supplyPeriod = supplyPeriod;
      let imgUrl,
        text = typeName;
      switch (typeName) {
        case "商服用地":
          imgUrl = require("@/assets/images/home/syyd.png");
          break;
        case "住宅用地":
          imgUrl = require("@/assets/images/home/zzyd.png");
          break;
        case "工矿仓储用地":
          imgUrl = require("@/assets/images/home/gkyd.png");
          break;
        case "其他用地":
          imgUrl = require("@/assets/images/home/qtyd.png");
          break;
        case "上架地块":
          imgUrl = require("@/assets/images/home/lan-icon.png");
          break;
        case "已成交地块":
          imgUrl = require("@/assets/images/home/pay-icon.png");
          break;
        case "待成交地块":
          imgUrl = require("@/assets/images/home/nopay-icon.png");
          break;
        case "立等可供":
          imgUrl = require("@/assets/images/common/img001.png");
          break;
        case "规划可用":
          imgUrl = require("@/assets/images/common/img003.png");
          break;
        case "计划可供":
          imgUrl = require("@/assets/images/common/img002.png");
          break;
      }
      this.dialogTableTitle.img = imgUrl;
      this.dialogTableTitle.text = text;
    },
    // 主页 供应期限统计接口
    supplyPeriodIndex() {
      getSupplyPeriodIndex({ county: this.county }).then((res) => {
        if (res.data.success) {
          this.available = res.data.data[0];
          // this.available.planAvailableArea = parseInt(
          //   this.available.planAvailableArea
          // );
          // this.available.planningAvailableArea = parseInt(
          //   this.available.planningAvailableArea
          // );
          // this.available.waitingForSupplyArea = parseInt(
          //   this.available.waitingForSupplyArea
          // );
        }
      });
    },
  },
};
</script>
<style scoped>
::v-deep .el-dialog__body {
  padding: 8px 20px 30px 20px;
}

.census {
  width: 100%;
  padding-top: 10px;
  margin: auto;
}

.census-select {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.mgn-b {
  margin-bottom: 10px;
}

.census-land {
  /* margin: 10px 0; */
}

.census-land-li {
  width: 100%;
  height: 95px;
  display: flex;
  align-items: center;
  border: 1px dashed #c9c7c7;
  /*padding: 10px 0;*/
}

.census-land-li1 {
  /*width: 100%;*/
  /*height: 165px;*/
  padding: 10px 0;
  display: flex;
  align-items: center;
  border: 1px dashed #c9c7c7;
  justify-content: space-between;
}
.census-land-li2 {
  padding: 10px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow-x: auto;
}
.census-land-li2::-webkit-scrollbar {
  width: 6px;
  height: 4px;
  background-color: #cfe0f5;
  border-radius: 4px;
}
.census-land-li2::-webkit-scrollbar-thumb {
  background-color: rgba(113, 155, 199, 0.7);
  /* background-color: rgba(8, 49, 94, 0.7); */
  border-radius: 4px;
}
.census-land-li-l {
  width: 80px;
  text-align: center;
  font-size: 0.95em;
  font-weight: 600;
}

.census-land-li-r {
  /* width: calc(100% - 100px);
   margin-left: 20px; */
  width: 100%;
  height: 100%;
  /*width: calc(100% - 40px);*/
  /*padding: 0 20px;*/
  display: flex;
  /* flex-wrap: wrap; */
  justify-content: space-between;
  padding: 0 20px;
  overflow-x: auto;
}

.census-land-li-r-box {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 20px;
}
.census-land-li1-r-box1 {
  display: flex;
  align-items: center;
  height: 50%;
  /* margin: 10px 0px; */
  width: 40%;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 15px;
  /* margin-left: 10px; */
}
.census-land-li1-r-box1:nth-child(2n) {
  padding-left: 10px;
  box-sizing: border-box;
}

.census-land-li1-r {
  /* width: calc(100% - 100px); */
  width: calc(100% - 20px);
  padding: 0 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  overflow: auto;
}

.census-land-li1-r-box-l1 {
  width: 30px;
  cursor: pointer;
}

.census-land-li1-r-box-l1 img {
  width: 35px;
}

.census-land-li1-r-box-r {
  /*display: flex;*/
  /*justify-content: space-between;*/
  width: calc(100%);
  margin-left: 15px;
}

.census-land-li1-r-box-r-span {
  text-align: left;
  /*width: 100px;*/
  color: #909399;
  font-weight: 400;
  font-size: 0.85rem;
}
.census-land-li1-r-box-r-span2 {
  display: flex;
  align-items: center;
  /* justify-content: space-between; */
  /*width: 140px;*/
  color: #909399;
  font-weight: 400;
  /*flex: 1;*/
  width: 100%;
  /*margin-left: 30px;*/
}

.census-land-li1-bot {
  /* min-width: 150px; */
  display: flex;
  align-items: center;
  width: 45%;
  /* width: max-content; */
  margin-right: 10px;
  margin-left: 10px;
}
.census-land-li1-bot:last-child {
  margin-right: 0;
}
.census-land-li1-bot-r {
  margin-left: 10px;
  width: inherit;
}
.census-land-li-r-box-l {
  width: 40px;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}

.census-land-li-r-box-l > img {
  width: 50px;
  height: 50px;
}

.census-land-li-r-box-l1 {
  width: 50px;
  display: flex;
}

.census-land-li-r-box-l1 > img {
  width: 40px;
  margin: auto;
  height: 35px;
}

.census-land-li-r-box-r {
  /*display: flex;*/
  /*align-items: center;*/
  /*justify-content: center;*/
  margin-left: 15px;
  width: max-content;
}

.census-land-li-r-box-r-span {
  font-size: 0.9em;
  color: #909399;
  font-weight: bold;
  /*text-align: center;*/
}

.number-c {
  margin-top: 15px;
  color: #fca942 !important;
  font-weight: 600;
  font-size: 1.12rem;
}

.span-c {
  margin-top: 15px;
  font-size: 0.75rem;
  font-weight: 600;
  padding-left: 5px;
  color: #636363;
}

.number-n {
  /* margin-left: 15px; */
  color: #3e8f9a !important;
  font-weight: 600;
  font-size: 1.12rem;
}

.span-n {
  margin-top: 15px;
  font-size: 0.75rem;
  font-weight: 600;
  padding-left: 3px;
}

.dialogTitle {
  display: flex;
  border-bottom: 2px solid #f0f6ff;
  padding-bottom: 10px;
  margin-bottom: 10px;
  position: relative;
}

.dialogTitle::after {
  content: "";
  border-left: 122px solid #3c86ca;
  border-bottom: 1px solid #3c86ca;
  border-top: 1px solid #3c86ca;
  position: absolute;
  bottom: 0px;
}

.dialogTitle img {
  width: 30px;
}

.dialogTitle span {
  font-size: 1.25rem;
  color: #0281c7;
  font-weight: bold;
  margin-left: 10px;
}
.other-land {
  /*text-align: right;*/
  /*flex: 1;*/
}
/*.other-land {*/
/*  text-align: justify;*/
/*  flex: 1;*/
/*  line-height:0*/
/*}*/
/*.other-land::after{*/
/*  content: '';*/
/*  display: inline-block;*/
/*  padding-left: 100%;*/
/*}*/
.land2 {
  display: flex;
  align-items: center;
  padding-bottom: 0px;
}
.census-land-li-r::-webkit-scrollbar {
  width: 6px;
  height: 4px;
  background-color: #cfe0f5;
  border-radius: 4px;
}
.census-land-li-r::-webkit-scrollbar-thumb {
  background-color: rgba(113, 155, 199, 0.7);
  /* background-color: rgba(8, 49, 94, 0.7); */
  border-radius: 4px;
}
.census-land-li3 {
  margin-top: 10px;
  padding: 10px 0;
  display: flex;
  align-items: center;
  border: 1px dashed #c9c7c7;
  justify-content: space-between;
  overflow-x: auto;
  background-image: url("../../../assets/images/programme-bg.png");
  background-size: 100%, 100%;
  background-repeat: no-repeat;
}
.programme {
  margin-left: 25px;
  flex: 3;
  display: flex;
  align-items: center;
}
.programme-area {
  flex: 2;
  /* margin-right: 150px; */
}
</style>
